<template>
  <div class="container mt-5">
    <h2 class="mb-4 text-center text-primary">
      {{ proveedor ? 'Editar Proveedor' : 'Alta de Proveedor' }}
    </h2>
    <!-- Formulario de Alta/Edición -->
    <form @submit.prevent="submitForm" class="card p-4 shadow-sm">
      <div class="mb-3">
        <label for="nombre" class="form-label">Nombre</label>
        <input type="text" id="nombre" class="form-control" v-model="form.nombre"
          :class="{ 'is-invalid': errores.nombre }" required />
        <div v-if="errores.nombre" class="invalid-feedback">{{ errores.nombre }}</div>
      </div>

      <div class="mb-3">
        <label for="contacto" class="form-label">Contacto/Persona</label>
        <input type="text" id="contacto" class="form-control" v-model="form.contacto" />
      </div>

      <div class="mb-3">
        <label for="telefono" class="form-label">Teléfono</label>
        <input type="tel" id="telefono" class="form-control" v-model="form.telefono" pattern="[0-9+()\- ]{6,20}"
          inputmode="tel" placeholder="Ej: +54 9 11 1234 5678" :class="{ 'is-invalid': errores.telefono }" />
        <div v-if="errores.telefono" class="invalid-feedback">{{ errores.telefono }}</div>
      </div>

      <div class="mb-3">
        <label for="direccion" class="form-label">Dirección</label>
        <input type="text" id="direccion" class="form-control" v-model="form.direccion" />
      </div>

      <div class="mb-3">
        <label for="correo" class="form-label">Correo</label>
        <input type="email" id="correo" class="form-control" v-model="form.correo"
          :class="{ 'is-invalid': errores.correo }" />
        <div v-if="errores.correo" class="invalid-feedback">{{ errores.correo }}</div>
      </div>

      <!-- Botón con estado de carga -->
      <div class="text-center">
        <button type="submit" class="btn btn-primary w-100" :disabled="cargando">
          <span v-if="cargando" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{ cargando ? (proveedor ? 'Guardando...' : 'Creando...') : (proveedor ? 'Guardar Cambios' : 'Crear Proveedor') }}
        </button>

        <button type="button" class="btn btn-secondary mt-3 w-100" @click="$emit('cancelar')">
          Cancelar
        </button>
      </div>
    </form>

    <!-- Mensajes de éxito/error -->
    <div v-if="mensaje" class="alert mt-4 text-center" :class="mensajeError ? 'alert-danger' : 'alert-success'">
      {{ mensaje }}
    </div>
  </div>
</template>

<script>
import axios from '@/axios';

export default {
  props: {
    proveedor: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: {
        nombre: '',
        contacto: '',
        telefono: '',
        direccion: '',
        correo: ''
      },
      mensaje: '',
      mensajeError: false,
      errores: {},
      cargando: false,  // Estado para manejar el spinner de carga
      clubActual: this.$store.getters.getClubActual,
    };
  },
  watch: {
    proveedor: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.form = {
            nombre: newVal.nombre || '',
            contacto: newVal.contacto || '',
            telefono: newVal.telefono || '',
            direccion: newVal.direccion || '',
            correo: newVal.correo || ''
          };
        } else {
          this.form = {
            nombre: '',
            contacto: '',
            telefono: '',
            direccion: '',
            correo: ''
          };
        }
      }
    }
  },
  methods: {
    validarCampos() {
      this.errores = {};
      // Validación de teléfono
      const tel = this.form.telefono.trim();
      if (tel && !/^[0-9+()\s-]{6,20}$/.test(tel)) {
        this.errores.telefono = 'El teléfono debe tener entre 6 y 20 caracteres y solo puede contener números, espacios, paréntesis, guiones o el símbolo +.';
      }
      // Validación de correo
      const correo = this.form.correo.trim();
      if (correo && !/^\S+@\S+\.\S+$/.test(correo)) {
        this.errores.correo = 'Ingrese un correo electrónico válido.';
      }
      // Validación de nombre (ya estaba)
      if (!this.form.nombre.trim()) {
        this.errores.nombre = 'El nombre es obligatorio.';
      }
      return Object.keys(this.errores).length === 0;
    },
    async submitForm() {
      this.cargando = true;
      this.errores = {};
      // Validación frontend antes de enviar
      if (!this.validarCampos()) {
        this.cargando = false;
        return;
      }
      try {
        let response;
        if (this.proveedor && this.proveedor.id) {
          // Edición
          response = await axios.put(`/api/proveedores/${this.proveedor.id}`, { ...this.form, club_id: this.clubActual.id });
          this.mensaje = 'Proveedor editado exitosamente';
          alert('Proveedor editado exitosamente');
        } else {
          // Alta
          response = await axios.post('/api/proveedores', { form: this.form, club_id: this.clubActual.id });
          this.mensaje = 'Proveedor creado exitosamente';
          alert('Proveedor creado exitosamente');
        }
        this.mensajeError = false;
        this.$emit('guardar', response.data);
      } catch (error) {
        if (error.response && error.response.data.errors) {
          this.errores = error.response.data.errors;
        } else {
          this.mensaje = 'Error al guardar el proveedor';
          this.mensajeError = true;
        }
      } finally {
        this.cargando = false;
      }
    },

  },

};
</script>

<style scoped>
.container {
  max-width: 600px;
}

h2 {
  font-size: 2rem;
  font-weight: 700;
  color: var(--app-primary);
}

.card {
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.form-label {
  font-weight: bold;
}

button {
  padding: 0.75rem;
}

button[disabled] {
  cursor: not-allowed;
  opacity: 0.6;
}

.invalid-feedback {
  display: block;
  color: red;
}

.alert {
  font-size: 1.1rem;
}
</style>
